"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EDIT_USER_MODAL = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reduxModal = require("redux-modal");

var _blocks = require("@bueno/blocks");

var _components = require("../../../components");

const EDIT_USER_MODAL = 'EDIT_USER_MODAL';
exports.EDIT_USER_MODAL = EDIT_USER_MODAL;

class EditUserModal extends _react.PureComponent {
  render() {
    const {
      title,
      show,
      handleClose,
      error,
      disabled,
      submitText,
      userFormData,
      usersLookup,
      handleChange,
      handleSubmit,
      toggleSubUser,
      submitFunc,
      handleToggleDeactivate,
      toggleDeactivateWorking,
      user,
      groups,
      rolesSelectOptions
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_blocks.Modal, {
      isOpen: show,
      onRequestClose: handleClose,
      title: title
    }, /*#__PURE__*/_react.default.createElement(_blocks.ModalContent, null, /*#__PURE__*/_react.default.createElement(_components.EditUserForm, {
      formData: userFormData,
      userOptions: usersLookup,
      onChange: handleChange,
      error: error,
      disabled: disabled,
      toggleSubUser: toggleSubUser,
      handleToggleDeactivate: handleToggleDeactivate,
      toggleDeactivateWorking: toggleDeactivateWorking,
      user: user,
      groupOptions: groups,
      rolesSelectOptions: rolesSelectOptions
    })), /*#__PURE__*/_react.default.createElement(_blocks.ModalFooter, {
      style: {
        zIndex: 0
      }
    }, /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
      tight: true
    }, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
      "data-cy": "UserAdmin-cancelEditUser",
      thin: true,
      appearance: "outline",
      onClick: handleClose
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_blocks.Button, {
      "data-cy": "UserAdmin-editUser",
      thin: true,
      primary: true,
      onClick: () => handleSubmit(submitFunc)
    }, submitText))));
  }

}

(0, _defineProperty2.default)(EditUserModal, "propTypes", {
  title: _propTypes.default.string.isRequired,
  submitText: _propTypes.default.string.isRequired,
  error: _propTypes.default.string,
  show: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  toggleDeactivateWorking: _propTypes.default.bool,
  user: _propTypes.default.object,
  userFormData: _propTypes.default.object.isRequired,
  usersLookup: _propTypes.default.array.isRequired,
  groups: _propTypes.default.array.isRequired,
  rolesSelectOptions: _propTypes.default.array.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  handleSubmit: _propTypes.default.func.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  submitFunc: _propTypes.default.func.isRequired,
  toggleSubUser: _propTypes.default.func,
  handleToggleDeactivate: _propTypes.default.func.isRequired
});
const ConnectedEditUserModal = (0, _reduxModal.connectModal)({
  name: EDIT_USER_MODAL,
  getModalState: state => state.betaModal
})(EditUserModal);
var _default = ConnectedEditUserModal;
exports.default = _default;